import { useOrganizations } from '@apis/eloc/queries/use-organizations';
import { useOrganizationContext } from '@packages/legacy/organization-context';

export const useImpersonate = (): string => {
  const { selectedOrganization } = useOrganizationContext();
  const orgID = selectedOrganization?.customerID;

  const {
    data: organizations,
    isPending: isPendingOrganizations,
    isError: isErrorOrganizations,
  } = useOrganizations();

  if (isPendingOrganizations || isErrorOrganizations) {
    return '';
  }

  if (organizations.length === 1) {
    return '';
  }

  if (!orgID) {
    return '';
  }

  return `?cid=${orgID}`;
};
